// ============================================================================
// SWAHILI TRANSLATIONS - CHAPTER 5: KANISA LA MWANZO
// ============================================================================
// Viwango 53-65 (viwango 13, maswali 39)

export const chapter5Translations = {
  name: "Kanisa la Mwanzo",
  description: "Mtapokea nguvu...",
  
  spiritualWisdom: {
    principle: "Roho Mtakatifu hutoa nguvu na ujasiri wa kushuhudia",
    scripture: "Lakini mtapokea nguvu Roho Mtakatifu atakapokuja juu yenu, nanyi mtakuwa mashahidi wangu (Matendo 1:8)",
    application: "Kanisa linazaliwa katika moto wa Roho na linakua kwa ushuhuda wa ujasiri"
  },
  
  levels: {
    53: {
      name: "Kupaa Mbinguni",
      challenge: "Mtakuwa mashahidi wangu... hata mwisho wa dunia...",
      easy: {
        question: "Yesu alipaa mbinguni siku ngapi baada ya kufufuka?",
        options: ["Siku 30", "Siku 40", "Siku 50", "Siku 60"],
        hint: "Nambari ya Biblia ya maandalizi",
        funFact: "☁️ Siku 40 za mafundisho makali kabla ya utume wa kimataifa!"
      },
      medium: {
        question: "Yesu aliahidi nini kabla ya kupaa mbinguni?",
        options: [
          "Kurudi haraka",
          "Kutuma Roho Mtakatifu kwa nguvu",
          "Kujenga kanisa",
          "Kuadhibu waovu"
        ],
        hint: "Nguvu kutoka juu",
        funFact: "⚡ Ahadi ya Roho Mtakatifu - mabadiliko ya wanafunzi waliohofia!"
      },
      hard: {
        question: "Kupaa Mbinguni kunaashiria nini katika maisha yetu ya kiroho?",
        options: [
          "Mwisho wa uwepo wa Yesu",
          "Yesu anatawala mbinguni na anaombea ajili yetu",
          "Kuaga kwa mwisho",
          "Hadithi ya ishara"
        ],
        hint: "Inakuhusu uwepo hai katika utukufu",
        funFact: "👑 Yesu ameketi mkono wa kuume wa Mungu, anatawala na anaombea ajili yetu!"
      }
    },
    
    54: {
      name: "Pentekoste",
      challenge: "Wote wakajazwa Roho Mtakatifu na kuanza kusema...",
      easy: {
        question: "Pentekoste ilitokea siku ngapi baada ya Kupaa Mbinguni?",
        options: ["Siku 7", "Siku 10", "Siku 14", "Siku 20"],
        hint: "Karibia siku kumi",
        funFact: "🔟 Siku 10 za sala kwa bidii zinaandaa kumwagikwa kwa Roho!"
      },
      medium: {
        question: "Roho Mtakatifu alidhihirika kwa njia gani?",
        options: [
          "Kama upepo mkali",
          "Kama ndimi za moto zilizogawanyika",
          "Kama njiwa",
          "Kama nuru"
        ],
        hint: "Miali ya moto iliyokaa juu ya kila mwanafunzi",
        funFact: "🔥 Ndimi za moto: Roho hutoa ujasiri na kipawa cha lugha!"
      },
      hard: {
        question: "Pentekoste inawakilisha nini kwa Kanisa kote ulimwenguni?",
        options: [
          "Tukio la kihistoria lililotenganishwa",
          "Kuzaliwa rasmi kwa Kanisa la umisheni",
          "Muujiza wa udadisi",
          "Mwanzo wa sikukuu"
        ],
        hint: "Inakuhusu cheti cha kuzaliwa cha Kanisa",
        funFact: "🎂 Pentekoste = siku ya kuzaliwa kwa Kanisa, mwanzo wa utume wa kimataifa!"
      }
    },

    55: {
      name: "Hotuba ya Kwanza ya Petro",
      challenge: "Tutafanya nini, ndugu? Tubuni...",
      easy: {
        question: "Watu wangapi walibatizwa baada ya hotuba ya Petro?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Roho elfu tatu",
        funFact: "🌊 Ubatizo 3000 kwa siku moja - kuamka kwa ajabu kwa kiroho!"
      },
      medium: {
        question: "Petro alilaumu umati kuhusu nini?",
        options: [
          "Ujinga",
          "Kumsulubisha Yesu, Masihi",
          "Kukosa imani",
          "Unafiki"
        ],
        hint: "Dhambi kuu dhidi ya Mwana wa Mungu",
        funFact: "⚔️ Petro, aliyemkana Yesu, sasa anatangaza Uungu wake!"
      },
      hard: {
        question: "Mabadiliko ya Petro yanaonyesha vipi kazi ya Roho Mtakatifu?",
        options: [
          "Alikuwa msomi zaidi",
          "Kutoka mwenye hofu na kutoeleweka hadi jasiri na imara katika imani",
          "Alipata mamlaka",
          "Alibadilisha tabia"
        ],
        hint: "Inakuhusu utakaso na Roho",
        funFact: "🗿 'Mwanzi unaotikisika' unakuwa 'jabali imara' - nguvu ya mabadiliko!"
      }
    },

    56: {
      name: "Jumuiya ya Kwanza",
      challenge: "Waliendelea katika mafundisho ya mitume na ushirika...",
      easy: {
        question: "Wakristo wa kwanza walishiriki mali vipi?",
        options: [
          "Kila mmoja aliweka yake",
          "Walishiriki kila kitu",
          "Matajiri pekee walitoa",
          "Kwa wajibu wa kisheria"
        ],
        hint: "Kushiriki mali kwa hiari",
        funFact: "🤝 Upendo wa kindugu mkali sana hivi kwamba walishiriki kila kitu kwa hiari!"
      },
      medium: {
        question: "Wakristo wa kwanza walitumia muda wao kwa nini?",
        options: [
          "Biashara tu",
          "Mafundisho, ushirika, kumega mkate, maombi",
          "Kazi tu",
          "Burudani"
        ],
        hint: "Nguzo nne za maisha ya jumuiya",
        funFact: "⛪ Mafundisho, ushirika, Ekaristi, maombi - misingi ya Kanisa!"
      },
      hard: {
        question: "Kwa nini jumuiya hii ya kwanza ilivutia sana?",
        options: [
          "Walikuwa matajiri",
          "Upendo wa kweli na furaha zilinawiri kutoka umoja wao",
          "Waliahidi miujiza",
          "Walikosoa wengine"
        ],
        hint: "Inakuhusu ushuhuda hai wa upendo",
        funFact: "✨ 'Tazama jinsi wanavyopendana!' - ushuhuda wa kushawishi zaidi ya maneno!"
      }
    },

    57: {
      name: "Kuponya Kiwete",
      challenge: "Fedha na dhahabu sina, lakini hili ninalcho, ninakupa...",
      easy: {
        question: "Mtu huyu alikuwa kiwete kwa muda gani?",
        options: [
          "Miaka 20",
          "Miaka 30", 
          "Tangu kuzaliwa",
          "Miaka 10"
        ],
        hint: "Ulemavu tangu kuzaliwa",
        funFact: "🚶 Ulemavu wa miaka 40 uliponjwa papo hapo kwa jina la Yesu!"
      },
      medium: {
        question: "Petro alimponya kiwete kwa jina la nani?",
        options: [
          "Kwa jina la Mungu",
          "Kwa jina la Yesu Kristo wa Nazareti",
          "Kwa jina lake mwenyewe",
          "Kwa jina la Abrahamu"
        ],
        hint: "Jina linalozidi majina yote",
        funFact: "✊ Jina la Yesu linaendelea kutenda miujiza kupitia mitume!"
      },
      hard: {
        question: "Uponyaji huu unaashiria nini kwa Injili?",
        options: [
          "Muujiza wa kimatibabu tu",
          "Wokovu kamili unaoleta Yesu: wa kiroho na wa kimwili",
          "Nguvu ya mitume",
          "Hisani kwa maskini"
        ],
        hint: "Inakuhusu wokovu kamili wa mwanadamu",
        funFact: "🩺 Yesu huponya roho na mwili - wokovu kamili wa mwanadamu!"
      }
    },

    58: {
      name: "Mwanzo wa Mateso",
      challenge: "Ni wajibu kumtii Mungu zaidi kuliko wanadamu...",
      easy: {
        question: "Nani alikamatia Petro na Yohana baada ya kuponya kiwete?",
        options: [
          "Warumi",
          "Masadukayo na makuhani",
          "Watu",
          "Pilato"
        ],
        hint: "Mamlaka ya kidini ya Kiyahudi",
        funFact: "⛓️ Mateso ya kwanza ya kidini - Injili inasumbua utaratibu uliopo!"
      },
      medium: {
        question: "Mamlaka iliwakataza mitume kufanya nini?",
        options: [
          "Kuondoka Yerusalemu",
          "Kutofundisha tena kwa jina la Yesu",
          "Kutotenda miujiza tena",
          "Kutoomba tena"
        ],
        hint: "Marufuku ya kuhubiri",
        funFact: "🚫 Jaribio la kunyamazisha ukweli - haiwezekani kusitisha Injili!"
      },
      hard: {
        question: "Mitume ilijibu vipi marufuku hayo?",
        options: [
          "Waliogopa na kutii",
          "Walitangaza kwamba ni wajibu kumtii Mungu zaidi kuliko wanadamu",
          "Walijadiliana",
          "Walikimbia"
        ],
        hint: "Inakuhusu uaminifu zaidi ya sheria za kibinadamu",
        funFact: "⚖️ Kutotii raia kwa kumtii Mungu - ujasiri wa imani!"
      }
    },

    59: {
      name: "Anania na Safira",
      challenge: "Hukudanganya wanadamu, bali Mungu...",
      easy: {
        question: "Anania na Safira walisema uongo gani?",
        options: [
          "Hawakuwa na kitu cha kuuza",
          "Waliweka sehemu wakisema wanatoa yote",
          "Walikuwa maskini",
          "Hawakuwa wameolewa"
        ],
        hint: "Uongo kuhusu kiasi walichotoa",
        funFact: "💰 Kuweka sehemu kulikuwa halali, kudanganya kuhusu sadaka hapana!"
      },
      medium: {
        question: "Nini kilitokea baada ya uongo huo?",
        options: [
          "Walisamehewa",
          "Walifariki papo hapo",
          "Walifukuzwa",
          "Walitubu"
        ],
        hint: "Adhabu kali papo hapo",
        funFact: "⚱️ Hukumu kali kulinda usafi wa Kanisa lililozaliwa upya!"
      },
      hard: {
        question: "Kwa nini adhabu kali sana mwanzoni mwa Kanisa?",
        options: [
          "Mungu alikuwa mkatili",
          "Kuweka utakatifu unaohitajika kutoka kwa jumuiya",
          "Kuwatisha",
          "Bahati mbaya"
        ],
        hint: "Inakuhusu kulinda uadilifu wa kiroho",
        funFact: "🔥 Viwango vya juu mwanzoni kuweka utamaduni wa utakatifu!"
      }
    },

    60: {
      name: "Mashemasi Saba",
      challenge: "Chagueni miongoni mwenu watu saba wenye sifa njema...",
      easy: {
        question: "Mashemasi wangapi walichaguliwa?",
        options: ["5", "6", "7", "12"],
        hint: "Nambari ya ukamilifu",
        funFact: "7️⃣ Mashemasi saba kwa huduma - mpangilio wa kimungu wa Kanisa!"
      },
      medium: {
        question: "Jukumu lao kuu lilikuwa nini?",
        options: [
          "Kuhubiri Injili",
          "Kuhudumu mezani na kusaidia wajane",
          "Kubatiza walioomba",
          "Kusimamia fedha"
        ],
        hint: "Huduma ya kijamii na kimwili",
        funFact: "🍽️ Huduma mezani = shirika la kwanza la hisani la Kikristo!"
      },
      hard: {
        question: "Mpangilio huu unafunua nini kuhusu mtazamo wa Kikristo wa huduma?",
        options: [
          "Kazi ya kimwili ni duni",
          "Huduma ya kiroho na ya kimwili ni takatifu sawa",
          "Lazima tuwatenganishe watakatifu na wa kidunia",
          "Makuhani tu ndio wahudumu wa kweli"
        ],
        hint: "Inakuhusu utakatifu wa huduma yote ya upendo",
        funFact: "✨ Kuhudumu mezani kwa hadhi sawa na kuhubiri - huduma yote ni takatifu!"
      }
    },

    61: {
      name: "Stefano, Shahidi wa Kwanza",
      challenge: "Bwana, usiwahasibie dhambi hii! Akasema hivyo, akalala...",
      easy: {
        question: "Jukumu la Stefano lilikuwa nini katika Kanisa?",
        options: ["Mtume", "Shemasi", "Kuhani", "Nabii"],
        hint: "Mmoja wa saba waliochaguliwa kuhudumu",
        funFact: "✨ Stefano: shemasi anakuwa mhubiri mwenye nguvu na shahidi wa kwanza!"
      },
      medium: {
        question: "Stefano alilaumu viongozi wa Kiyahudi kuhusu nini?",
        options: [
          "Ufisadi",
          "Kumpinga Roho Mtakatifu daima",
          "Unafiki",
          "Tamaa"
        ],
        hint: "Upinzani wa kihistoria dhidi ya Mungu",
        funFact: "📜 Stefano anafupisha historia: uasi wa kudumu dhidi ya Mungu!"
      },
      hard: {
        question: "Stefano alikufa vipi na mtazamo wake unafunua nini?",
        options: [
          "Kwa hasira kwa wauaji",
          "Akisamehe kama Yesu msalabani",
          "Kwa kukata tamaa",
          "Akiwaapa adui"
        ],
        hint: "Inakuhusu kuiga Kristo kikamilifu",
        funFact: "💝 Msamaha kwa wauaji: Stefano anarudia kikamilifu mtazamo wa Yesu!"
      }
    },

    62: {
      name: "Filipo na Towashi wa Kietiopia",
      challenge: "Nitawezaje kuelewa asiponionyesha mtu?",
      easy: {
        question: "Towashi alikuwa anasoma nini gariini?",
        options: [
          "Zaburi",
          "Nabii Isaya",
          "Mwanzo",
          "Mithali"
        ],
        hint: "Nabii wa mateso ya Masihi",
        funFact: "📖 Isaya 53 - unabii kamili kuhusu Yesu unasomwa na mtafutaji wa kweli!"
      },
      medium: {
        question: "Filipo alielezea vipi kifungu cha Isaya?",
        options: [
          "Alizungumza historia ya kale",
          "Alimhubiri Yesu kutoka andiko hilo",
          "Alifundisha theolojia",
          "Alikosoa tafsiri"
        ],
        hint: "Maandiko yanaongoza kwa asili kwa Kristo",
        funFact: "✝️ Maandiko yote yanakusanyika kwa Yesu - ufunguo wa kuelewa!"
      },
      hard: {
        question: "Kuomba kwa towashi wa Kietiopia kunaashiria nini?",
        options: [
          "Kuomba kuliotenganishwa",
          "Ujumla wa Injili kwa makabila na hali zote",
          "Ubora wa kabila fulani",
          "Hali maalum"
        ],
        hint: "Inakuhusu kufunguliwa kwa mataifa",
        funFact: "🌍 Mwetiopia, towashi, waziri: Injili inavunja vizuizi vyote!"
      }
    },

    63: {
      name: "Kuomba kwa Saulo wa Tarso",
      challenge: "Saulo, Saulo, kwa nini unanisumbua?",
      easy: {
        question: "Saulo alikuwa akifanya nini kabla ya kuomba?",
        options: [
          "Kuhubiri Injili",
          "Kuwasumbua Wakristo",
          "Alikuwa wa wazi",
          "Kusoma tu"
        ],
        hint: "Adui mkali wa wanafunzi",
        funFact: "⚔️ Saulo alikuwa akitoa vitisho na mauaji dhidi ya wanafunzi wa Yesu!"
      },
      medium: {
        question: "Yesu alimtokea Saulo katika njia gani?",
        options: [
          "Njia ya Yerusalemu",
          "Njia ya Dameski",
          "Njia ya Gaza",
          "Njia ya Antiokia"
        ],
        hint: "Jiji katika Siria",
        funFact: "🛤️ Njia ya Dameski = mahali maarufu zaidi pa mabadiliko katika historia!"
      },
      hard: {
        question: "Kuomba huku kunaonyesha vipi neema ya Mungu?",
        options: [
          "Mungu huomba watu wema tu",
          "Neema inaweza kubadilisha adui mbaya zaidi kuwa mtume mkuu zaidi",
          "Kuomba kulistahili",
          "Saulo alikuwa tayari karibu na Mungu"
        ],
        hint: "Inakuhusu nguvu ya kubadilisha ya neema",
        funFact: "⚡ Kutoka msumbufu mkuu hadi mjumbe mkuu - muujiza wa neema!"
      }
    },

    64: {
      name: "Petro na Kornelio",
      challenge: "Kwa kweli natambua kwamba Mungu hapendelei uso...",
      easy: {
        question: "Kazi ya Kornelio ilikuwa nini?",
        options: [
          "Mfanyabiashara",
          "Jemadari wa Kirumi",
          "Kuhani",
          "Mwandishi"
        ],
        hint: "Afisa wa jeshi la Kirumi",
        funFact: "🎖️ Mtu wa kwanza asiye Myahudi kuomba rasmi - kufunguliwa kwa wasio Wayahudi!"
      },
      medium: {
        question: "Petro aliona maono gani kabla ya kukutana na Kornelio?",
        options: [
          "Malaika akizungumza",
          "Shuka yenye wanyama safi na najisi",
          "Yesu akionekana",
          "Hekalu lililoharibika"
        ],
        hint: "Maono kuhusu usafi na unajisi",
        funFact: "🕊️ Shuka yenye wanyama: Mungu anaondoa tofauti za chakula na makabila!"
      },
      hard: {
        question: "Kuomba huku kuliweka kanuni gani ya mapinduzi?",
        options: [
          "Warumi ni bora",
          "Mungu hapendelei uso - wokovu wa ulimwengu wote",
          "Lazima tuache mila",
          "Kutahiriwa hakuna maana"
        ],
        hint: "Inakuhusu ujumla wa wokovu",
        funFact: "🌍 Mapinduzi ya kiroho: Injili ni kwa mataifa yote bila ubaguzi!"
      }
    },

    65: {
      name: "Kanisa la Antiokia",
      challenge: "Huko Antiokia wanafunzi waliitwa Wakristo kwa mara ya kwanza...",
      easy: {
        question: "Wanafunzi waliitwa nini kwa mara ya kwanza huko Antiokia?",
        options: ["Wanafunzi", "Wakristo", "Waumini", "Watakatifu"],
        hint: "Jina tunalolotumia leo",
        funFact: "✝️ 'Wakristo' = 'Wakristo wadogo' - jina la heshima kutoka kwa wapagani!"
      },
      medium: {
        question: "Nani alikuja kufundisha Antiokia pamoja na Barnaba?",
        options: [
          "Petro",
          "Paulo (Saulo)",
          "Yakobo",
          "Yohana"
        ],
        hint: "Msumbufu wa zamani aliyekuwa mtume",
        funFact: "👥 Barnaba anamtafuta Paulo huko Tarso - mwanzo wa huduma ya Paulo!"
      },
      hard: {
        question: "Kwa nini Antiokia ilikuwa muhimu sana katika historia ya Kikristo?",
        options: [
          "Ilikuwa tajiri",
          "Kituo cha kwanza cha umisheni kwa wapagani",
          "Ilikuwa mahali pazuri",
          "Walikuwa na viongozi wazuri"
        ],
        hint: "Inakuhusu upanuzi wa umisheni",
        funFact: "🚢 Antiokia: bandari ya kuondokea ya safari zote za umisheni za Paulo kwenda Ulaya!"
      }
    }
  }
};

export default chapter5Translations;
